import {useState} from 'react';
import {Button, Input, InputNumber, Card, Row, message} from 'antd';
import {insertExpense} from "../../api/Api";
import {BankSelectWidget} from "../widget/BankSelectWidget";
import {VendorSelectWidget} from "../widget/VendorSelectWidget";
import {DatePickerWidget} from "../widget/DatePickerWidget";

const {TextArea} = Input;

export const NewExpense = ({refresh, onRefresh, onApiFail, props}) => {
    const [amount, setAmount] = useState (undefined)
    const [department, setDepartment] = useState(undefined);
    const [category, setCategory] = useState(undefined);
    const [bank, setBank] = useState(undefined);
    const [notes, setNotes] = useState(undefined);
    const [vendor, setVendor] = useState(undefined);
    const [date, setDate] = useState(undefined);
    const [messageApi, contextHolder] = message.useMessage();

    // displayDate is important, we are working around a UTC to local timezone change
    // we need to feed DatePickerWidget a local time so that it works as expected, otherwise date is off by 1
    const [displayDate, setDisplayDate] = useState(undefined);

    const onDepartmentChange = (e) => {
        setDepartment(e.target.value);
    }

    const onAmountChange = (val) => {
        setAmount(val);
    }

    const onCategoryChange = (e) => {
        setCategory(e.target.value);
    }

    const onBankChange = (val) => {
        console.log(`bank ${val}`);
        setBank(val);
    }

    const onNotesChange = (e) => {
        setNotes(e.target.value);
    }

    const onDateChange = (dateString, dateJS) => {
        setDate(dateString);

        const dateJsString = dateJS.toString();

        // we will set displayDate to a local time for DatePickerWidget
        setDisplayDate(dateJsString);
    }

    const clearForm = () => {
        setAmount(undefined);
        setDepartment(undefined);
        setCategory(undefined);
        setBank(undefined);
        setNotes(undefined);
        setVendor(undefined);
        setDate(undefined);
        setDisplayDate(undefined);
    }

    const onConfirm = () => {
        insertExpense(amount, bank, department, category, notes, vendor.id, date).then(r => {
            clearForm();
            if (onRefresh) onRefresh();
            messageApi.open({
                type: "success",
                content: "Expense added successfully"
            });
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
            messageApi.open({
                type: "error",
                content: "Failed to add expense"
            })
        });
    }

    const onVendorChange = (val, option) => {
        console.log(val);
        setVendor(option.vendor)
    }

    const amountUndefined = amount === undefined || amount === null;
    const bankUndefined = bank === undefined || bank === null;
    const vendorUndefined = vendor === undefined || vendor === null;
    const saveDisabled = amountUndefined || bankUndefined || vendorUndefined;

    let errorMessage = "";
    if (amountUndefined) errorMessage += "Set an amount.  "
    if (bankUndefined) errorMessage += "Set an account.  "
    if (vendorUndefined) errorMessage += "Set a vendor.  "


    const rowStyle= {margin: '5px'}

    return <div style={{textAlign: 'left', width: '800px'}}>
        {contextHolder}
        <Card title={`Enter New Expense`} orientation={'left'}>
            <Row style={rowStyle}>
                <InputNumber min={0} precision={2} value={amount} placeholder={'amount'} addonBefore={'$'} onChange={onAmountChange} />
            </Row>
            <Row style={rowStyle}>
                <BankSelectWidget accountId={bank} setAccountId={onBankChange} onApiFail={onApiFail} />
            </Row>
            <Row style={rowStyle}>
                <DatePickerWidget placeholder={"Back Date"} onChange={onDateChange} date={displayDate} />
            </Row>
            <Row style={rowStyle}>
                <Input value={department} placeholder={`department`} onChange={onDepartmentChange} />
            </Row>
            <Row style={rowStyle}>
                <Input value={category} placeholder={'category'} onChange={onCategoryChange} />
            </Row>
            <Row style={rowStyle}>
                <TextArea value={notes} onChange={onNotesChange} placeholder={'Notes'} maxLength={512} rows={4} showCount />
            </Row>
            <Row style={rowStyle}>
                <VendorSelectWidget onApiFail={onApiFail} onSelect={onVendorChange} />
            </Row>
            <Row style={rowStyle}>
                <Button disabled={saveDisabled} onClick={onConfirm}>Save</Button>
            </Row>
            <Row style={{rowStyle}}>
                {(errorMessage.length > 0) && <div style={{color: 'red'}}>{errorMessage}</div>}
            </Row>
        </Card>
    </div>
}